var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SectionWithFilter',{attrs:{"splitter-key":_vm.formId,"filter-config":_vm.filterConfig,"content-wrapped":""}},[_c('ProvidableDriversSection',{ref:"tabComponent",attrs:{"organization-id":_vm.objectId,"form-id":_vm.formId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }